export default __webpack_public_path__ + "static/media/wallet.efe6ae36.svg";